import type { ReactNode } from "react";
import { Grid, Typography } from "@mui/material";

export type InvoiceFieldProps = {
  label: string;
  /** What the field shows. Anything falsy (null, false, "") shows `empty`
   * in muted text instead, so `x && <…/>` reads naturally at the call site. */
  value: ReactNode;
  empty?: string;
  /** Columns from `sm` up; a phone always gets the full width. */
  size?: number;
};

/** One labelled, read-only field of the invoice view. */
export const InvoiceField = ({
  label,
  value,
  empty = "None",
  size = 6,
}: InvoiceFieldProps) => (
  <Grid size={{ xs: 12, sm: size }}>
    <Typography
      variant="subtitle2"
      gutterBottom
      sx={{ color: "text.secondary" }}
    >
      {label}
    </Typography>
    {value || (
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {empty}
      </Typography>
    )}
  </Grid>
);
